import React from 'react';
import loadable from '@loadable/component';

const AccommodationDetail = loadable(() => import('../components/AccommodationDetail/AccommodationDetail'));

const AccommodationDetailsPage = () => {
  return <AccommodationDetail />;
}
export default AccommodationDetailsPage;